<app-expandable-section-box
  [title]="'Sponsors'"
  [iconClass]="'icon-bullhorn'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
  data-testid="sponsorsComponentSection"
  id="sponsorsComponentSection"
>
  <div
    class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1"
    data-testid="sponsorsComponent"
    id="sponsorsComponent"
    expandedContent
  >
    <div class="p-2">
      <mat-checkbox
        data-testid="sponsorsCheckboxComponent"
        id="sponsorsCheckboxComponent"
        color="primary"
        [formControl]="isSponsored"
        (change)="updateEditingSponsors()"
      >
        Sponsored Content
      </mat-checkbox>
    </div>
    <div
      class="flex flex-col flex-1 px-0 py-3 m-0 border-t border-t-project-100"
      *ngIf="this.selectedSponsor?.value"
    >
      <span>{{ this.selectedSponsor?.value?.name }}</span>
      <div
        *ngIf="!editingSponsor && this.selectedSponsor?.value?.name"
        class="py-1 text-xs"
      >
        <a (click)="updateEditingSponsors()"
          >(<span class="hover:text-project-2100">change sponsor</span>)</a
        >
      </div>
    </div>
    <app-auto-complete
      *ngIf="editingSponsor"
      id="formSectionSponsorsAuto"
      data-testid="formSectionSponsorsAuto"
      class="flex flex-col flex-1"
      [placeholder]="'Search for a sponsor'"
      [searchList]="searchSponsorList"
      [searchBarControl]="searchedSponsor"
      [isSearching]="isSearchingSponsors"
      (handleSelectedResult)="handleSponsorSelected($event)"
    ></app-auto-complete>
  </div>
  <div
    class="flex flex-col gap-y-[0.3rem] p-4 flex-1"
    *ngIf="selectedSponsor?.value"
    notExpandedContent
  >
    <ng-container>
      <p class="py-px text-xs text-project-2400">
        {{ this.selectedSponsor?.value?.name }}
      </p>
    </ng-container>
  </div>
</app-expandable-section-box>
